module.exports = __webpack_public_path__ + "assets/img/gif-3.281046ca.jpg";